<template>
  <div
    class="checkox_container"
  >
    <input
      v-model="hideState"
      type="checkbox"
      style="margin: 0 0.3rem; cursor: pointer;"
      @change="updateState($event)"
    >
    <label>
      {{ capitalizeFirstLetter($t('resource.hide')) }}
    </label>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';


export default {
  name: 'PublicationCheckbox',

  props: {
    isMain: {
      type: Boolean,
      default: true
    },
    resource: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      hideState: false,
      initiating: true
    };
  },

  computed: {
    ...mapState('datasets', [
      'currentDataset'
    ]),
  },

  watch: {
  
  },

  created() {
    this.initiating = true;
    this.hideState=!this.resource.published;
    this.$nextTick(() => {
      this.initiating = false;
    });
  },

  methods: {
    updateState(e){
      console.log(e);
      this.resource.published=!this.hideState;
      this.$emit('statechanged');
    }
  }

};
</script>

<style lang="less" scoped>
.checkox_container {
  display: flex;
  align-items: center;
}
.checkox_container.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>